/**
 * Navegação do Portal Operacional — uma fonte só para a barra inferior (celular)
 * e as abas (tablet/desktop). Cinco destinos: é o que cabe no polegar.
 */
import { PORTAL_BASE } from "./open-app";

export interface PortalNavItem {
  key: "inicio" | "checklists" | "ocorrencias" | "veiculos" | "manutencao";
  label: string;
  to: string;
  /** a rota raiz não pode "acender" em todas as filhas */
  end?: boolean;
}

export const PORTAL_NAV: PortalNavItem[] = [
  { key: "inicio", label: "Início", to: PORTAL_BASE, end: true },
  { key: "checklists", label: "Checklists", to: `${PORTAL_BASE}/checklists` },
  { key: "ocorrencias", label: "Ocorrências", to: `${PORTAL_BASE}/ocorrencias` },
  { key: "veiculos", label: "Veículos", to: `${PORTAL_BASE}/veiculos` },
  { key: "manutencao", label: "Manutenção", to: `${PORTAL_BASE}/manutencao` },
];

export const portalPaths = {
  home: PORTAL_BASE,
  checklists: `${PORTAL_BASE}/checklists`,
  newChecklist: (kind?: "frota" | "manutencao" | "diario") =>
    `${PORTAL_BASE}/checklists/novo${kind === "manutencao" || kind === "diario" ? `?tipo=${kind}` : ""}`,
  run: (id: string) => `${PORTAL_BASE}/checklists/${id}`,
  occurrences: `${PORTAL_BASE}/ocorrencias`,
  maintenance: `${PORTAL_BASE}/manutencao`,
  workOrder: (id: string) => `${PORTAL_BASE}/ordens/${id}`,
  tires: `${PORTAL_BASE}/pneus`,
  vehicles: `${PORTAL_BASE}/veiculos`,
  vehicle: (plate: string) => `${PORTAL_BASE}/veiculos/${encodeURIComponent(plate)}`,
};

/** Item ativo para um caminho — a rota mais específica vence. */
export function activeNavKey(pathname: string): PortalNavItem["key"] | null {
  const candidatos = PORTAL_NAV.filter((i) =>
    i.end ? pathname === i.to || pathname === `${i.to}/` : pathname === i.to || pathname.startsWith(`${i.to}/`),
  );
  const maisEspecifico = candidatos.sort((a, b) => b.to.length - a.to.length)[0];
  if (maisEspecifico) return maisEspecifico.key;
  if (pathname.startsWith(`${PORTAL_BASE}/pneus`)) return "inicio";
  return null;
}
